export default "__VITE_ASSET__Cth9$5fj__"